/**
 *
 *
 * ENUMS
 *
 *
 */

export enum ElementType {
  Text = "Text",
  Button = "Button",
  Image = "Image",
  AppStoreButton = "AppStoreButton",
  SocialLinks = "SocialLinks",
  Form = "Form",
  Video = "Video",
  Counter = "Counter",
  Embed = "Embed",
  Map = "Map",
}

export enum ButtonDesignStyle {
  Primary = "Primary",
  Secondary = "Secondary",
  Tertiary = "Tertiary",
}

export enum ButtonDesignSize {
  Fit = "Fit",
  Fill = "Fill",
}

export enum ButtonActionType {
  InternalLink = "InternalLink",
  ExternalLink = "ExternalLink",
  Email = "Email",
  Phone = "Phone",
  Button = "Button",
  Submit = "Submit",
}

export enum ImageActionType {
  InternalLink = "InternalLink",
  ExternalLink = "ExternalLink",
  ScaleUp = "ScaleUp",
  DoNothing = "DoNothing",
}

export enum ImageObjectFit {
  "None" = "None",
  "Fill" = "Fill",
  "Cover" = "Cover",
  "Contain" = "Contain",
}

export enum AppStoreButtonDesignSize {
  "Small" = "Small",
  "Medium" = "Medium",
  "Large" = "Large",
}
export enum AppStoreButtonActionType {
  "Apple" = "Apple",
  "Google" = "Google",
  "Samsung" = "Samsung",
  "Huawei" = "Huawei",
}
export enum AppStoreButtonDesignStyle {
  "Brand" = "Brand",
  "Black" = "Black",
  "White" = "White",
}

export enum SocialLinkName {
  "Behance" = "behance",
  "Discord" = "discord",
  "Dribbble" = "dribbble",
  "Facebook" = "facebook",
  "Messenger" = "messenger",
  "Github" = "github",
  "Instagram" = "instagram",
  "Linkedin" = "linkedin",
  "Pinterest" = "pinterest",
  "Skype" = "skype",
  "Telegram" = "telegram",
  "Tiktok" = "tiktok",
  "Twitter" = "twitter",
  "Whatsapp" = "whatsapp",
  "Youtube" = "youtube",
  "Snapchat" = "snapchat",
}

export enum FieldType {
  "Text" = "Text",
  "Email" = "Email",
  "Phone" = "Phone",
  "TextArea" = "TextArea",
  "Link" = "Link",
  "Date" = "Date",
  "Checkbox" = "Checkbox",
  "Radio" = "Radio",
  "Select" = "Select",
  "Time" = "Time",
  "File" = "File",
}

export enum FormPostSubmitType {
  "Message" = "Message",
  "Redirect" = "Redirect",
}

export enum AutoCompleteType {
  "Name" = "name",
  "UserName" = "username",
  "OrganizationTitle" = "organization-title",
  "Organization" = "organization",
  "StreetAddress" = "street-address",
  "AddressLine1" = "address-line1",
  "AddressLine2" = "address-line2",
  "AddressLine3" = "address-line3",
  "Country" = "country",
  "CountryName" = "country-name",
  "PostalCode" = "postal-code",
  "Language" = "language",
  "Sex" = "sex",
  "Email" = "email",
  "Phone" = "phone",
  "Url" = "url",
}

export enum SelectionsLimitationType {
  "Limited" = "Limited",
  "Unlimited" = "Unlimited",
}

export enum ShadowType {
  "none" = "none",
  "outer" = "outer",
  "inner" = "inner",
}

export enum IconShape {
  "Filled" = "Filled",
  "Outlined" = "Outlined",
  "Colored" = "Colored",
}

export enum UtilityPageType {
  "NOT_FOUND_PAGE" = "NOT_FOUND_PAGE",
  "UNDER_MAINTENANCE_PAGE" = "UNDER_MAINTENANCE_PAGE",
}

export enum ColorsType {
  brand1 = "--theme-color-brand1",
  brand2 = "--theme-color-brand2",
  brand3 = "--theme-color-brand3",
  brand4 = "--theme-color-brand4",
  secondary1 = "--theme-color-secondary1",
  secondary2 = "--theme-color-secondary2",
  secondary3 = "--theme-color-secondary3",
  secondary4 = "--theme-color-secondary4",
  base1 = "--theme-color-base1",
  base2 = "--theme-color-base2",
  base3 = "--theme-color-base3",
  base4 = "--theme-color-base4",
  base5 = "--theme-color-base5",
  accent1 = "--theme-color-accent1",
  accent2 = "--theme-color-accent2",
}
